<template>
  <div class="header-dropdown" :class="{ active: isActive }">
    <div class="header-dropdown__wrapper">
      <div class="header-dropdown__content">
        <div
          v-if="favouritesStore.state.favourites.length > 0"
          class="header-favourite"
        >
          <router-link
            class="header-favourite__icon"
            :to="{ name: 'Favorites' }"
            aria-label="Избранные квартиры"
          >
            <Icon icon="heart" />
            <span class="header-favourite__label">{{
              favouritesStore.state.favourites.length
            }}</span>
            <span class="header-favourite__text">Избранное</span>
          </router-link>
        </div>
        <div class="header-dropdown__group group">
          <h5 class="group__title" @click="toggleGroupList('project')">
            Сенсация
            <Icon icon="arrow" :class="{ rotated: openGroups['project'] }" />
          </h5>
          <ul class="group__list" :class="{ open: openGroups['project'] }">
            <li class="group__item">
              <router-link :to="{ path: '/', hash: '#about' }"
                >О проекте</router-link
              >
            </li>
            <li class="group__item">
              <router-link :to="{ path: '/', hash: '#advantages' }"
                >Преимущества</router-link
              >
            </li>
            <li class="group__item">
              <router-link :to="{ path: '/', hash: '#gallery' }"
                >Галерея</router-link
              >
            </li>
            <li class="group__item">
              <router-link :to="{ path: '/', hash: '#environment' }"
                >Расположение</router-link
              >
            </li>
          </ul>
        </div>

        <div class="header-dropdown__group group">
          <h5 class="group__title" @click="toggleGroupList('lots')">
            Выбор лотов
            <Icon icon="arrow" :class="{ rotated: openGroups['lots'] }" />
          </h5>
          <ul class="group__list" :class="{ open: openGroups['lots'] }">
            <li class="group__item">
              <router-link :to="{ name: 'PlanSearch' }">Планировки</router-link>
            </li>
          </ul>
        </div>

        <div class="header-dropdown__group group">
          <h5 class="group__title" @click="toggleGroupList('purchaser')">
            Покупателям
            <Icon icon="arrow" :class="{ rotated: openGroups['purchaser'] }" />
          </h5>
          <ul class="group__list" :class="{ open: openGroups['purchaser'] }">
            <li class="group__item">
              <router-link :to="{ path: '/', hash: '#purchase' }"
                >Ипотека</router-link
              >
            </li>
          </ul>
        </div>

        <div class="header-dropdown__group group">
          <h5 class="group__title" @click="toggleGroupList('information')">
            Информация
            <Icon
              icon="arrow"
              :class="{ rotated: openGroups['information'] }"
            />
          </h5>
          <ul class="group__list" :class="{ open: openGroups['information'] }">
            <li class="group__item">
              <router-link :to="{ name: 'News' }">Новости </router-link>
            </li>
            <li class="group__item">
              <router-link :to="{ name: 'Construction' }">Ход строительства </router-link>
            </li>
            <li class="group__item">
              <a 
                href="https://наш.дом.рф/сервисы/единый-реестр-застройщиков/застройщик/23289"
                target="_blank"
              >
                Документы
              </a>
            </li>
            <li class="group__item">
              <router-link :to="{ path: '/', hash: '#contacts' }"
                >Контакты</router-link
              >
            </li>
          </ul>
        </div>

        <a
          class="header-dropdown__group group-link"
          href="https://gk-osnova.ru/"
          target="_blank"
        >
          Все проекты ОСНОВЫ
          <img class="group-link__logo" src="~@i/link-icon.svg" alt="лого" />
        </a>
      </div>
      <div class="header-dropdown__footer">
        <div class="btn btn-default">
          <router-link :to="{ name: 'PlanSearch' }"
            >Выбрать квартиру</router-link
          >
        </div>
        <div class="osnova-button">
          <div
            class="osnova-button__wrapper"
            href="https://gk-osnova.ru/"
            target="_blank"
          >
            <div class="osnova-button__logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="144"
                height="42"
                viewBox="0 0 144 42"
                fill="none"
              >
                <g>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M33.3818 9.71104V32.0464L41.7294 40.2508V17.9155L33.3818 9.71104ZM32.6084 32.8066H9.88892L18.2393 41.0139H40.9587L32.6084 32.8066ZM8.33063 32.8066V8.95912L0 0.760234V41.0139H16.6923L8.34192 32.8066H8.33063ZM9.09566 8.19057H33.3734L41.7294 16.3923V0H0.773498L9.10695 8.19057H9.09566Z"
                    fill="#3f4440"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M54.3197 20.8204C54.3197 25.0987 55.5533 26.7496 57.7806 26.7496C60.1011 26.7496 61.2614 25.0849 61.2614 20.8204C61.2614 16.5558 60.0758 14.9189 57.7806 14.9189C55.4855 14.9189 54.3197 16.5697 54.3197 20.8204ZM65.5157 20.8204C65.5157 26.3391 62.6249 29.6685 57.7806 29.6685C52.9364 29.6685 50.0852 26.4361 50.0852 20.8204C50.0852 15.3295 52.9787 12 57.8004 12C62.622 12 65.5353 15.2074 65.5353 20.8204H65.5157Z"
                    fill="#3f4440"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M80.1657 13.8474L78.1898 16.1559C77.3607 15.3846 76.2654 14.9504 75.1239 14.9406C72.9446 14.9406 71.4146 16.6664 71.4146 20.795C71.4146 24.8541 72.9248 26.58 75.1973 26.58C76.5524 26.58 77.5461 25.9224 78.5369 25.1677L80.3634 27.5012C79.6589 28.1917 78.8222 28.7385 77.9016 29.1099C76.9811 29.4814 75.9948 29.6701 74.9997 29.6653C70.3023 29.6653 67.1631 26.5549 67.1631 20.7867C67.1631 15.1486 70.4774 11.9912 74.8755 11.9912C77.2017 11.9912 78.7571 12.671 80.1657 13.8391V13.8474Z"
                    fill="#3f4440"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M86.2227 22.0376V29.2515H82.169V12.4153H86.2227V18.9245H91.3634V12.4153H95.4201V29.2515H91.3634V22.0376H86.2227Z"
                    fill="#3f4440"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M101.719 20.8204C101.719 25.0987 102.956 26.7496 105.18 26.7496C107.506 26.7496 108.672 25.0849 108.672 20.8204C108.672 16.5558 107.481 14.9189 105.18 14.9189C102.88 14.9189 101.719 16.5669 101.719 20.8204ZM112.918 20.8204C112.918 26.3391 110.027 29.6685 105.177 29.6685C100.328 29.6685 97.4707 26.4361 97.4707 20.8204C97.4707 15.3295 100.361 12 105.177 12C109.994 12 112.918 15.2074 112.918 20.8204Z"
                    fill="#3f4440"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M120.505 26.3631C122.408 26.3631 123.771 25.9719 123.771 24.1241C123.771 22.4232 122.563 21.7906 120.804 21.7906H119.026V26.3604L120.505 26.3631ZM119.026 19.1492H120.533C122.227 19.1492 123.102 18.5166 123.102 17.1071C123.102 15.6977 122.165 15.237 120.209 15.237H119.026V19.1492ZM127.946 24.3461C127.946 28.1887 124.782 29.2542 120.479 29.2542H114.969V12.4153H119.813C124.409 12.4153 127.226 13.5556 127.226 16.7159C127.226 18.8552 125.671 19.9733 124.084 20.3367C125.99 20.7002 127.941 21.6242 127.941 24.3432L127.946 24.3461Z"
                    fill="#3f4440"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M136.113 15.3065L134.312 22.7423H137.92L136.113 15.3065ZM133.62 25.6223L132.754 29.2293H128.564L133.716 12.4153H138.637L143.808 29.2515H139.5L138.611 25.6445L133.62 25.6223Z"
                    fill="#3f4440"
                  />
                </g>
              </svg>
            </div>
            <a
              class="osnova-button__link"
              href="https://gk-osnova.ru/"
              target="_blank"
            >
              <p class="osnova-button__link-desk">
                Перейти <br />
                на сайт ОСНОВЫ
              </p>
              <p class="osnova-button__link-mobile">Сайт ОСНОВЫ</p>
              <img
                class="group-link__logo"
                src="~@i/link-icon.svg"
                alt="лого"
              />
            </a>

            <div class="osnova-button__cosial">
              <ul>
                <li v-for="(value, name) in $social" :key="name">
                  <a
                    :href="value.url"
                    :aria-label="'Мы в ' + value.name"
                    target="_blank"
                    rel="noreferrer"
                    ><Icon :icon="name"
                  /></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import _forEach from "lodash/forEach";
import { is_touch } from "@/helpers.js";
export default {
  inject: ["favouritesStore", "mainStore"],
  props: {
    isActive: {
      type: Boolean,
    },
  },
  data() {
    return {
      openGroups: {
        project: false,
        lots: true,
        purchaser: false,
        information: false,
      },
    };
  },
  watch: {
    isActive(status) {
      if (status) {
        this.disableBodyScroll();
      } else {
        this.enableBodyScroll();
      }
      if (!is_touch()) {
        if (status) {
          const tlShow = gsap.timeline();
          _forEach(this.$refs, (element) => {
            tlShow.add(
              gsap.fromTo(
                element.children,
                {
                  y: 20,
                  autoAlpha: 0,
                },
                {
                  y: 0,
                  autoAlpha: 1,
                  stagger: { each: 0.07 },
                  duration: 0.3,
                }
              ),
              0
            );
          });
        } else {
          const tlHide = gsap.timeline();
          _forEach(this.$refs, (element) => {
            tlHide.add(
              gsap.fromTo(
                element.children,
                {
                  y: 0,
                  autoAlpha: 1,
                },
                {
                  y: 20,
                  autoAlpha: 0,
                  stagger: { each: 0.07 },
                  duration: 0.3,
                }
              ),
              0
            );
          });
        }
      }
    },
  },
  methods: {
    disableBodyScroll() {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    },
    enableBodyScroll() {
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    },
    toggleGroupList(groupName) {
      this.openGroups[groupName] = !this.openGroups[groupName];
    },
  },
};
</script>

<style scoped>
.header-dropdown {
  position: absolute;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: calc(100vh - 100%);
  margin-top: 1px;
  border-bottom: 1px solid #e5e5e5;
  background: #fff;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  overflow: auto;
}

.header-dropdown.active {
  opacity: 1;
  visibility: visible;
  padding: 20px;
}

.header-dropdown__wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
      180deg,
      rgba(255, 0, 32, 0) -59.54%,
      rgba(255, 0, 32, 0.27035) 26.72%,
      rgba(255, 0, 32, 0.5) 100%
    ),
    url(~@i/background-menu.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.header-dropdown__wrapper::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: inherit;
  filter: blur(10px);
  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.2) 30%,
    rgba(0, 0, 0, 1) 100%
  );
  z-index: 1;
}

.header-dropdown__content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1330px;
  padding-top: 35px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  margin: 0 auto;
}

h5,
.group-link {
  font-size: 24px;
  text-transform: none;
  color: #ffffff;
  margin-bottom: 24px;
  font-weight: 500;
}

ul {
  margin: 0;
  list-style-type: none;
}

a {
  color: #ffffff;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s ease, opacity 0.3s ease;
}

a:hover {
  color: #ff0020;
}

.group-link {
  display: flex;
  align-items: center;
  gap: 12px;
}

.group-link__logo {
  width: 22px;
  height: 27px;
}

.group__item > a {
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
}

.header-dropdown__footer {
  position: relative;
  z-index: 10;
  margin-top: auto;
  padding: 40px;
}

.osnova-button {
  display: flex;
  position: relative;
  width: max-content;
  background: #fff;
  border-radius: 10px;
}

.osnova-button__logo {
  padding: 25px;
  position: relative;
  border-right: 1px solid #291f1f26;
}

.osnova-button__wrapper {
  display: flex;
}

.osnova-button__link {
  display: flex;
  align-items: center;
  gap: 30px;
  color: #291f1f;
  padding: 15px 25px;
}

.osnova-button__link-mobile {
  display: none;
}

p {
  margin: 0;
}

.osnova-button__cosial {
  padding: 25px 17px;
}

.osnova-button__cosial ul {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}

.osnova-button__cosial ul li {
  margin: 0 12px 0 0;
  padding: 0;
}

.osnova-button__cosial ul li:last-child {
  margin-right: 0;
}

.osnova-button__cosial ul li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ff0020;
}

.osnova-button__cosial ul li a svg {
  transition: opacity 0.1s, fill 0.1s;
}

body.-notouch .osnova-button__cosial ul li a:hover {
  background: #800010;
}

body.-notouch .osnova-button__cosial ul li a:hover svg {
  opacity: 1;
  fill: #fff;
}

body.-notouch .osnova-button__cosial ul li a:active {
  background: #800010;
}

.icon-arrow {
  display: none;
}

.btn {
  display: none;
}

.header-favourite {
  display: none;
}

@media (max-width: 1080px) {
  .header-dropdown.active {
    background: #f3f1f1;
    padding: 30px 15px;
  }

  .header-dropdown__wrapper {
    height: auto;
    min-height: 100%;
    background: none;
  }

  .header-dropdown__content {
    flex-direction: column;
    padding: 0;
  }

  .header-dropdown__footer {
    padding: 0;
  }

  .group__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    color: #291f1f;
    font-size: 20px;
  }

  .group__item > a {
    color: #291f1f99;
  }

  .header-dropdown__group {
    width: 100%;
  }

  .header-dropdown__group.group-link {
    align-items: flex-start;
    font-size: 20px;
    color: #291f1f;
  }

  .icon-arrow {
    display: block;
  }

  .icon-arrow.rotated {
    transform: rotate(180deg);
  }

  .group__list {
    display: none;
  }

  .group__list.open {
    display: block;
  }

  .btn {
    display: flex;
    position: relative;
    z-index: 2;
  }

  .osnova-button {
    margin-top: 20px;
    background: none;
    width: 100%;
  }

  .osnova-button__wrapper {
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .osnova-button__logo {
    display: none;
  }

  .osnova-button__cosial {
    order: -1;
    padding: 0;
  }

  .osnova-button__link {
    gap: 14px;
    background: #fff;
    border-radius: 10px;
    padding: 10px 15px;
    height: 51px;
  }

  .osnova-button__link-desk {
    display: none;
  }

  .osnova-button__link-mobile {
    display: block;
  }

  .header-favourite {
    position: relative;
    display: flex;
    align-items: center;
    height: 72px;
  }

  .header-favourite__text {
    position: absolute;
    top: 3px;
    left: 58px;
    color: #3f4440;
    font-weight: normal;
    font-size: 20px;
  }

  .router-link-active:not(.unactive-link) .header-favourite__text,
  body.-notouch a:hover .header-favourite__text {
    color: #205640;
  }
}
</style>
